<template>
  <v-footer app class="app-footer">
    <span>&copy; Cristian Caram 2018</span>
  </v-footer>
</template>
<script>
export default {
  name: 'Footer'
}
</script>
<style/>
